import React from 'react';
import { Link } from 'react-router-dom'
import heroImg from '../../images/Kodo1.png'
import icon from '../../images/icons/icon_stars_trustpilot.svg'
// import Bg1 from '../../images/shapes/it_solution_hero_bg_1.svg'
// import Bg2 from '../../images/hero/it_solution_hero_image_2.svg'
// import avatar1 from '../../images/avatar/avatar_1.webp'
// import avatar2 from '../../images/avatar/avatar_2.webp'
// import avatar3 from '../../images/avatar/avatar_3.webp'

const Hero = () => {

    return (
        <section className="it_solution_hero_section pb-0">
            <div className="container">
                <div className="row position-relative">
                        <div className="it_solution_hero_content" style={{ backgroundColor : '#dffdee' }}>
                    <div className="col-md-7 col-lg-7">
                            <div className="heading_focus_text mb-0 d-inline-flex align-items-center">👋 Hello! We Are <span className="badge bg-secondary text-white">Kodo 😃</span></div>
                            <h2 >
                           Start your IT career in AI ML today 
                            </h2>
                            <p>
                            Complete a 6-month pathway to advanced AI/ML skills with an intensive, skills-focused blended curriculum.
                            </p>
                            <ul className="btns_group unordered_list p-0 justify-content-start">
                                <li>
                                    <Link className="btn " to="/contact" style={{backgroundColor: "#1DBF73", borderColor: '#1DBF73'}}>
                                        <span className="btn_label" data-text="Enroll Now">JOIN PROGRAM</span>
                                        <span className="btn_icon">
                                            <i className="fa-solid fa-arrow-up-right"></i>
                                        </span>
                                    </Link>
                                </li>
                                <li>
                                    <div className="review_short_info">
                                        <div className="d-flex">
                                            <img src={icon} alt="Techco - Trustpilot Review" />
                                            <span>4.8</span>
                                        </div>
                                        <div className="review_counter">From <b>200+</b> reviews</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    <img src={heroImg} className="kodo-logo w-100" alt="IT Program Academy In Coimbatore" />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Hero;